import { render, staticRenderFns } from "./FscHorizontalTable.vue?vue&type=template&id=4f45900a&"
import script from "./FscHorizontalTable.vue?vue&type=script&lang=ts&"
export * from "./FscHorizontalTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports